import { UseMutationDefaultOptions } from '@front/hook/Api/common';
import { importTaskQueryKeys } from '@front/hook/Api/ImportTask/queryKeys';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { ImportTableDefinitionRepository } from '@front/repository/Api/ImportTableDefinition';
import type { IImportTableDefinitionRepository } from '@front/repository/Api/ImportTableDefinition/interface';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { importTableDefinitionQueryKeys } from './queryKeys';

const repository = new ImportTableDefinitionRepository();

export const _create = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: IImportTableDefinitionRepository.Create.Params) => {
      return repository.create(params, { signal: signalToTimeout(DEFAULT_TIMEOUT.MUTATION_WITH_JOB_DISPATCH) });
    },
    onSuccess: async (_data, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: importTableDefinitionQueryKeys.listPrefix(variables.projectId),
          refetchType: 'all',
        }),
        variables.fileId
          ? queryClient.invalidateQueries({
              queryKey: importTaskQueryKeys.listPrefix(variables.projectId),
              refetchType: 'all',
            })
          : Promise.resolve(),
      ]);
    },
    ...UseMutationDefaultOptions,
  });
};
